<template>
    <div
        class="md-team layout3 mg-bg"
        :style="{
            ...spaceStyle,
            ...colorStyle
        }"
    >
        <ul class="f-col">
            <li v-for="(agent, index) in agents" class="agent"  :class="{reverse: agentDirection === 'left' }" :key="agent.id">
                <a
                    class="team-layout3-img img-container"
                    :target="detailUrlTarget"
                    :href="
                        useExternalUrl
                            ? agent.externalUrl || agent.detailUrl
                            : agent.detailUrl
                    "
                    :style="index === 0 ? imageStyle || {} : {}"
                    rel="noopener noreferrer"
                    :aria-label="agentAlt(agent)"
                >
                    <img-box
                        class="image"
                        :src="agent.headShotOneByOne || ''"
                        :alt="agentAlt(agent)"
                        errorImg="https://cdn.chime.me/image/fs/sitebuild/202457/7/original_fbb918b4-831d-43d3-8d96-68f8986a8e79.png"
                    />
                </a>
                <div class="team-layout3-main" v-animated="textAnimation(index)">
                    <div
                        v-if="agent.fullName"
                        class="agent-name"
                        :class="{ name: !agent.position }"
                    >
                        <a
                            :href="agent.detailUrl"
                            :target="detailUrlTarget"
                            rel="noopener noreferrer"
                            :aria-label="agent.fullName"
                        >{{ agent.fullName }}</a>
                    </div>
                    <div
                        class="agent-position"
                        v-if="
                            agent.position ||
                                agent.license ||
                                agent.licenseWithState
                        "
                    >
                        <span v-if="agent.position" class="sp">
                            {{ agent.position }}
                        </span>
                        <span
                            v-if="agent.license || agent.licenseWithState"
                            class="sp"
                        >
                            {{ licenseName }}
                            {{ agent.licenseWithState || agent.license }}
                        </span>
                    </div>
                    <div
                        class="single-intro"
                        v-if="agent.longIntroduction"
                        v-html="agent.longIntroduction"
                    ></div>
                    <div class="license-company">
                        <a
                            v-if="agent.phone"
                            :href="'tel:' + agent.phone"
                            target="_top"
                            rel="noopener noreferrer"
                        >
                            <i class="iconfont icon-phone1"></i>
                            {{ $ft.formatPhone(agent.phone) }}
                        </a>
                        <a
                            v-if="agent.email"
                            :href="'mailto:' + agent.email"
                            rel="noopener noreferrer"
                        >
                            <i class="iconfont icon-v5-email"></i>
                            {{ agent.email }}
                        </a>
                        <p v-if="agent.address">
                            <i class="iconfont icon-v5-address"></i>
                            {{ agent.address }}
                        </p>
                        <a
                            v-if="agent.externalUrl"
                            :href="agent.externalUrl"
                            :target="detailUrlTarget"
                            rel="noopener noreferrer"
                        >
                            <i class="iconfont icon-icon-test"></i>
                            {{ agent.externalUrl }}
                        </a>
                    </div>
                    <Share
                        v-if="agent.agentSocialNetworks.length"
                        :socialNetworks="agent.agentSocialNetworks"
                    />
                    <site-button
                        type="plain"
                        class="book-appointment"
                        target="_blank"
                        :href="agent.calendarLink"
                        v-if="enableBookAppointment && agent.calendarLink"
                        :html="$t('md-team.bookAppointment')"
                    />
                </div>
            </li>
        </ul>
        <pagination
            v-if="total > 1"
            :totalPage="total"
            @pageChange="pageChange"
            :pageSize="pageSize"
            :noScroll="true"
            :pageNum="pageNum"
        />
    </div>
</template>

<script>
import common from '../index-layout.js';
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
import Share from '../broker-float/share';
export default {
    mixins: [common],
    components: {
        Share
    },
    data: function() {
        return {
            imageStyle: {},
            containerStyle: {}
        };
    },
    computed: {
        ...mapState(usePageStore, {
            company: store => store.companyInfo
        }),
        isMobile() {
            return this.platform.isMobile;
        }
    },
    methods: {
        textAnimation(index) {
            let animationName;
            if (this.isMobile) {
                animationName = 'shift-right';
            } else {
                if (this.agentDirection == 'right') {
                    if (index % 2 === 0) {
                        animationName = 'shift-right';
                    } else {
                        animationName = 'shift-left';
                    }
                } else {
                    if (index % 2 === 0) {
                        animationName = 'shift-left';
                    } else {
                        animationName = 'shift-right';
                    }
                }
            }
            return {
                name: animationName,
                enable: this.showAnimationEffects
            }
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-team.layout3 {
    line-height: 1.5;
    .agent {
        display: flex;
        row-gap: 20px;
        column-gap: 7.5%;
        .team-layout3-main {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 48.5%;
            @include media-600 {
                width: 100%;
            }
            .agent-name {
                font-size: 24px;
                color: var(--g-primary-color);
                line-height: 1;
                font-family: var(--mg-title-font);
                @include media-600 {
                    font-size: 18px;
                }
            }
            .agent-position {
                color: var(--g-tip-color);
                padding-top: 15px;
                font-size: 14px;
                @include media-600 {
                    padding-top: 10px;
                    font-size: 12px;
                }
                .sp + .sp:before {
                    content: '|';
                    display: inline-block;
                    padding: 0 5px;
                }
            }
            .single-intro {
                padding-top: 20px;
                padding-bottom: 15px;
                font-size: 18px;
                color: var(--g-primary-color);
                @include media-600 {
                    padding-top: 15px;
                    font-size: 14px;
                    padding-bottom: 0px;
                }
            }
            .license-company {
                padding-top: 55px;
                color: var(--g-text-color);
                font-size: 14px;
                :not(:first-child) {
                    display: block;
                    margin-top: 6px;
                }
                .iconfont {
                    margin-right: 10px;
                }
                .icon-v5-email {
                    font-size: 14px;
                }
                @include media-600 {
                    padding-top: 20px;
                }
            }
            .book-appointment {
                margin-top: 50px;
                width: 225px;
                height: 50px;
                text-transform: uppercase;
                font-size: 16px;
                font-weight: 500;
                @include media-600 {
                    margin-top: 15px;
                    width: 100%;
                }
            }
            .share-links {
                margin-top: 45px;
                margin-left: -5px;
                .iconfont {
                    display: inline-flex;
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    color: var(--g-primary-color);
                    background: rgba(218, 218, 218, 0.5);
                    justify-content: center;
                    align-items: center;
                    font-size: 22px;
                    margin: 5px;
                    &:hover {
                        color: #fff;
                    }
                    &.icon-agent-facebook {
                        &:hover {
                            background-color: #4063b3;
                        }
                    }
                    &.icon-tik-tok {
                        &:hover {
                            background-color: #000;
                        }
                    }
                    &.icon-agent-linkedin {
                        &:hover {
                            background-color: #0a8dcb;
                        }
                    }
                    &.icon-newagent-twitter {
                        &:hover {
                            background-color: #000;
                        }
                    }
                    &.icon-agent-zillow {
                        &:hover {
                            background-color: #006aff;
                        }
                    }
                    &.icon-agent-yelp {
                        &:hover {
                            background-color: #af0606;
                        }
                    }
                    &.icon-agent-yelp {
                        &:hover {
                            background-color: #af0606;
                        }
                    }
                    &.icon-instagram {
                        &:hover {
                            background-image: linear-gradient(
                                44deg,
                                #f7de01 6%,
                                #f92002 40%,
                                #dd1e49 52%,
                                #b12973 62%,
                                #7837aa 87%
                            );
                        }
                    }
                    &.icon-youtube1 {
                        &:hover {
                            background-color: #f00;
                        }
                    }
                    &.icon-snapchat {
                        &:hover {
                            background-color: #eddb02;
                        }
                    }
                    &.icon-agent-pinterest {
                        &:hover {
                            background-color: #e70023;
                        }
                    }
                    &.icon-angelist-square {
                        &:hover {
                            background-color: #191919;
                        }
                    }
                    &.icon-google-sign {
                        &:hover {
                            background-color: #ea4336;
                        }
                    }
                    &.icon-agent-whatsapp {
                        &:hover {
                            background-color: #1acf40;
                        }
                    }
                    &.icon-redfin-simple {
                        &:hover {
                            background-color: #c82021;
                        }
                    }
                    @include media-600 {
                        width: 40px;
                        height: 40px;
                        font-size: 20px;
                    }
                }
                @include media-600 {
                    margin-top: 15px;
                }
            }
        }
        .team-layout3-img {
            position: relative;
            width: 44%;
            padding-top: 44%;
            max-height: 1000px;
            overflow: hidden;
            flex-shrink: 0;
            flex-grow: 0;
            @include media-600 {
                width: auto;
                padding-top: 100%;
            }
            .img-box {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                transition: transform 0.3s ease;
                &:hover {
                    transform: scale(1.1);
                }
            }
        }
        @include media-600 {
            flex-direction: column;
        }
        @include media-min-600 {
            
            &:nth-of-type(2n + 1) {
                flex-direction: row-reverse;
            }
            &.reverse:nth-of-type(2n) {
                flex-direction: row-reverse;
            }
            &.reverse:nth-of-type(2n + 1) {
                flex-direction: row;
            }
        }
    }
    .agent + .agent {
        padding-top: 80px;
        @include media-600 {
            padding-top: 40px;
        }
    }
}
</style>
